<template>
  <input
      ref="evInput"
      :class="getClasses"
      v-bind="$attrs"
      :style="getStyles"
      :value="resolvedValue"
      @input="inputHandler"
      @change="changeHandler"
  />
</template>
<script>
let nextInputId = 0;

export default {
  name: 'EvInput',
  inheritAttrs: false,
  emits: ['input', 'update:modelValue', 'update:value', 'change', 'diff'],
  data() {
    return {
      classes: [
        "border",
        "border-main-600",
        "appearance-none",
        "py-2",
        "px-4",
        "leading-tight",
        "focus:outline-none",
        "transition-ease"
      ],
      isChanged: false,
      availablePasswordChar: /[0-9a-zA-Z!@#$%^&*\s]*/ig,
      invalid: false,
      mutateValue: null,
      isDiff : false,
      originValue: null,
      uniqueId: `ev-input-${++nextInputId}`
    }
  },
  props: {
    autoMax: {default: null, required: false},
    value: { default: undefined },
    modelValue: { default: undefined },
    diffCheck: {type: Boolean, default: false},
    hasError: {type: Boolean, default: false}
  },
  watch:{
    resolvedValue :{
      handler(val){
        if( this.originValue === this.getUidForDiff && this.diffCheck && val !== null){
          // 맨처음 값 입니다.
          this.originValue = val;
        }
        if(
            !(this.originValue === null || this.originValue === '')
            && this.originValue !== this.getUidForDiff
            && this.originValue != val
        ){
          this.isDiff = true;
          // 원래값과 변경된 값을 보내줍니다.
          this.$emit('diff', [this.originValue, val]);
        }else{
          this.isDiff = false;
          this.$emit('diff', []);
        }
      }
    }
  },
  computed: {
    resolvedValue() {
      return typeof this.modelValue !== 'undefined' ? this.modelValue : this.value;
    },
    getInputType() {
      return (this.$attrs['type']) ? this.$attrs['type'] : 'text';
    },
    hasErrorField() {
      return this.hasError;
    },
    getClasses() {
      let mode = 'default';
      if (this.diffCheck && this.isDiff) {
        mode = 'diff';
      }
      if (this.hasErrorField) {
        mode = 'error';
      }

      let typeClasses = [];
      switch (mode) {
        case 'default':
          typeClasses = [
            "text-main-900",
            "focus:border-primary-600",
          ];
          break;
        case 'diff' :
          typeClasses = [
            "bg-orange-200",
            "text-orange-700",
            "focus:bg-orange-100",
            "focus:border-orange-300",
          ];
          break;
        case 'error' :
          typeClasses = [
            "bg-red-200",
            "text-red-700",
            "focus:bg-red-100",
            "focus:border-red-300",
          ];
          break;
      }
      if (this.$attrs['type'] === 'password') {
        typeClasses.push('ime-inactive');
      }

      return typeClasses.concat(this.classes);
    },
    isNumberType() {
      return this.$attrs['type'] === 'number';
    },
    isPasswordType() {
      return this.$attrs['type'] === 'password';
    },
    getStyles() {
      let style = {};
      if (this.$attrs['style'] && typeof this.$attrs['style'] === 'object' && !Array.isArray(this.$attrs['style'])) {
        style = { ...this.$attrs['style'] };
      }
      if( !style.hasOwnProperty('minHeight')){
        style['minHeight'] = '40px';
      }
      if (this.autoMax) {
        style['max-width'] = this.autoMax + 'px';
        if( this.mutateValue ){
          let length = this.getHelperDiv.offsetWidth + 32;
          if( (length) > parseInt(this.autoMax) ){
            style['max-width'] = length + 'px';
          }
        }
      }


      return style;
    },
    getUnique() {
      return this.uniqueId;
    },
    getAutoMaxHelperDivId() {
      return 'div_proxy_' + this.getUnique;
    },
    getHelperDiv() {
      return document.getElementById(this.getAutoMaxHelperDivId);
    },
    getUidForDiff(){
      return 'original#' + this.uniqueId;
    }
  },
  methods: {
    inputHandler(e) {
      let value = e.target.value;

      this.emitValue(value);

      this.mutateValue = value;
      if(this.autoMax){
        this.getHelperDiv.innerText = value;
      }

    },
    emitValue(value) {
      this.$emit('update:modelValue', value);
      this.$emit('update:value', value);
      this.$emit('input', value);
    },
    changeHandler(e) {
      this.$emit('change', e.target.value);
    },
    createProxyDiv() {
      const div = document.createElement('div');
      div.id = this.getAutoMaxHelperDivId;
      div.style.width = 'auto';
      div.style.display = 'inline-block';
      div.style.visibility = 'hidden';
      div.style.position = 'fixed';
      div.style.overflow = 'auto';
      document.body.appendChild(div);
    }
  },
  mounted() {
    if(this.diffCheck){

      if(this.resolvedValue){
        this.originValue = this.resolvedValue;
      }else{
        this.originValue = this.getUidForDiff;
      }

    }

    if(this.autoMax){
      this.createProxyDiv();
    }
  },
  beforeUnmount() {
    if (this.getHelperDiv) {
      this.getHelperDiv.remove();
    }
  }
}
</script>
<style scoped>
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
